{
  "version": 1,
  "asset_id": "af4ab2b7-0fa0-4666-8ee1-70d9499643e6",
  "project_id": "b5943ba6-0f61-4928-b23c-a966ef99f6df",
  "url": "/__l5e/assets-v1/af4ab2b7-0fa0-4666-8ee1-70d9499643e6/celina-collection-wefts-new.png",
  "r2_key": "a/v1/b5943ba6-0f61-4928-b23c-a966ef99f6df/af4ab2b7-0fa0-4666-8ee1-70d9499643e6/celina-collection-wefts-new.png",
  "original_filename": "celina-collection-wefts-new.png",
  "size": 515495,
  "content_type": "image/png",
  "created_at": "2026-09-23T21:17:29Z"
}
